export default function CardTable({ children }) {
  return children;
}
